import { ASSET_PATHS } from "./assets";

export const InfoCard = ({ 
  title, 
  description, 
  bgColor = "bg-transparent", 
  iconSrc,
  iconLink,
}) => (
  <div className={`relative border border-white/30 rounded-2xl p-6 md:p-8 w-full md:w-[calc(33.333%-1rem)] backdrop-blur-sm hover:border-white/70 transition-all duration-300 ${bgColor} hover:shadow-[0_0_20px_-5px_rgba(255,255,255,0.3)] overflow-hidden group`}>
    {/* Gradient overlay */}
    <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
    
    {/* Animated border effect */}
    <div className="absolute inset-0 rounded-2xl p-[1px] pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-400/0 via-purple-600/30 to-pink-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
    </div>
    
    <div className="relative z-10">
      <div className="flex flex-row justify-between items-center mb-4">
        <h3 className="text-2xl md:text-3xl lg:text-4xl bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300">
          {title}
        </h3>
        {iconLink ? (
          iconLink.startsWith("#") ? (
            <a href={iconLink}>
              <img 
                src={iconSrc} 
                alt="Arrow icon" 
                className="w-6 h-6 md:w-8 md:h-8 hover:scale-110 transition-transform duration-200" 
              />
            </a>
          ) : (
            <a href={iconLink} target="_blank" rel="noopener noreferrer">
              <img 
                src={iconSrc} 
                alt="Arrow icon" 
                className="w-6 h-6 md:w-8 md:h-8 hover:scale-110 transition-transform duration-200" 
              />
            </a>
          )
        ) : (
          <img 
            src={iconSrc} 
            alt="Arrow icon" 
            className="w-6 h-6 md:w-8 md:h-8" 
          />
        )}

      </div>
      <p className="text-sm md:text-md lg:text-base mt-4 font-kodeMono text-gray-300">
        {description}
      </p>
    </div>
  </div>
);
export const InfoCardsSection = () => (
  <section className="bg-gradient-to-b from-[#1d1e26] to-[#080912] text-white font-pixel py-16 md:py-24">
    <div className="container mx-auto px-4">
      <div className="flex flex-col md:flex-row items-stretch justify-center gap-6 md:gap-8">
        <InfoCard
          title="For Individual"
          description="Automatic security and streamline verification with our RT-powered CRPTCHR solver. Enhance efficiency and protect your online operations without interruptions."
          bgColor="bg-gradient-to-b from-indigo-900/20 to-indigo-900/5"
          iconSrc={ASSET_PATHS.buttons.upArrow}
          iconLink="#extenion" 
        />
        <InfoCard
          title="For Developers"
          description="Integrate our API seamlessly into your automation workflows. With high-speed solving and robust security, power your applications with RT-driven efficiency."
          bgColor="bg-gradient-to-b from-purple-900/20 to-purple-900/5"
          iconSrc={ASSET_PATHS.buttons.upArrow}
          iconLink="https://docs.captchasonic.com/"
        />
        <InfoCard
          title="For Enterprises"
          description="Unlock enterprise-grade CRPTCHR-solving with advanced RT. Ensure smooth data operations, web scraping, and automation at scale with industry-leading precision."
          bgColor="bg-gradient-to-b from-pink-900/20 to-pink-900/5"
          iconSrc={ASSET_PATHS.buttons.upArrow}
          iconLink="#contact"
        />
      </div>
    </div>
  </section>
);